import { BankratePropertyUse } from '@bankrate/mortgage-types'
import { DefaultEmailCapture } from 'components/email-capture/DefaultEmailCapture'
import { LowCoverageEmailCapture } from 'components/email-capture/LowCoverageEmailCapture'
import isMatch from 'lodash/isMatch'
import { FC } from 'react'

export interface EmailFormConfig {
  berockEventName: string
  Component: FC<any>
  location: string
  criteria: {
    isWeekday?: boolean
    withinBusinessHours?: boolean
    loanType?: 'Purchase' | 'Refinance'
    isCashout?: boolean
    isVA?: boolean
    isFHA?: boolean
    propertyUse?: BankratePropertyUse | null
  }
}

export const defaultEmailFormConfig = {
  berockEventName: 'mortgage_rate_alerts_instant_event',
  Component: DefaultEmailCapture,
  location: 'lowCoverageInput',
  criteria: {
    // No criteria for the defatult email capture
  },
}

export const emailFormConfigService = {
  // These configs are checked in the defined order
  getEmailFormConfigs(): EmailFormConfig[] {
    return [
      {
        berockEventName: 'mortgage_rates_alert_instant_event',
        location: 'lowCoverageHour',
        Component: LowCoverageEmailCapture,
        criteria: {
          // Use this one when the user is not within business hours
          withinBusinessHours: false,
        },
      },
      {
        berockEventName: 'mortgage_rates_alert_instant_event',
        location: 'lowCoverageHour',
        Component: LowCoverageEmailCapture,
        criteria: {
          // Use this one when the user is viewing on a weekend
          isWeekday: false,
        },
      },
    ]
  },

  findEmailFormConfig(criteria: EmailFormConfig['criteria']) {
    const foundConfig = this.getEmailFormConfigs().find(config => {
      // Checks if the left variable contains the same propertes and values of the right variable
      // This works well since the criteria can be any thing between all or none of the properties
      // TODO: This will not work if we want to start checking for ranges of things, however those
      // ranges could be translated into boolean or string properties
      return isMatch(criteria, config.criteria)
    })

    // The last case should always
    return foundConfig || defaultEmailFormConfig
  },
}
